import { StyleSheet } from 'react-native';
import { brand, gray_1, gray_2, gray_3, gray_7 } from '../../../styles/rn';
var styles = StyleSheet.create({
  webformPopupContent: {
    padding: 0
  },
  webformPopupContentContainer: {
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12
  },
  webformPopupTitleContainer: {
    height: 48
  },
  webformPreviewWrapper: {
    backgroundColor: '#fff'
  },
  webformPreviewHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 12
  },
  webformPreviewHeaderText: {
    color: gray_1,
    paddingLeft: 8,
    fontWeight: '500',
    fontSize: 16
  },
  webformPreviewContent: {
    fontSize: 14,
    paddingLeft: 12,
    paddingRight: 12
  },
  webformPreviewItem: {
    flexDirection: 'row',
    borderTopWidth: 1,
    borderColor: gray_7,
    borderStyle: 'solid',
    paddingTop: 8,
    paddingBottom: 8,
    paddingRight: 12,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  webformPreviewLabel: {
    color: gray_2,
    maxWidth: 140
  },
  webformPreviewValue: {
    color: gray_1,
    textAlign: 'right',
    maxWidth: 124
  },
  webformPreviewIcon: {
    width: 24,
    height: 24
  },
  webformWrapper: {
    flex: 1,
    backgroundColor: '#fff'
  },
  webformHeader: {},
  webformTitle: {
    flex: 1
  },
  webformHeaderIcon: {
    width: 24,
    height: 24
  },
  webformItemEditWrapper: {
    paddingTop: 16,
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 12
  },
  webformItemViewWrapper: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 16,
    paddingBottom: 12,
    paddingLeft: 12,
    paddingRight: 12,
    borderBottomWidth: 1,
    borderColor: gray_7,
    borderStyle: 'solid'
  },
  webformItemViewContent: {
    flex: 1
  },
  webformItemViewIcon: {
    width: 16,
    height: 16
  },
  webformItemViewLabel: {
    color: gray_2,
    paddingBottom: 12
  },
  webformItemViewValue: {
    color: gray_1
  },
  webformItemRequired: {
    color: brand,
    paddingLeft: 2
  },
  webformItemLabel: {
    flex: 1,
    flexDirection: 'row',
    color: gray_1,
    paddingBottom: 8
  },
  webformItemLabelText: {
    color: gray_1
  },
  webformItemTips: {
    flex: 1,
    color: gray_3,
    paddingBottom: 12
  },
  buttonWrapper: {
    flex: 1
  }
});
export default styles;